/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  Input,
  Form,
  Radio,
  Table,
  CascaderSelect,
} from '@alifd/next';
import moment from 'moment';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import 'antd/dist/antd.css';
import PerMonthPointsList from '../PerMonthPointsList';

const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
};

const HouseholdPoints = (props) => {
  const residentPointsRecord = client.service('residentPointsRecord');
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const [
    residentAccountNumbersAllArr,
    setResidentAccountNumbersAllArr,
  ] = useState([]);
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  // console.log(residentAccountNumbersArr)
  const [residentPointsRecordArr, setResidentPointsRecordArr] = useState([]);
  const [dataSourceSelect, setDataSourceSelect] = useState('');
  const [pointsType, setPointsType] = useState('');
  // console.log(pointsType)
  const [changePoints, setChangePoints] = useState('');

  const [perMonthPointsResult, setPerMonthPointsResult] = useState('');
  const [remarks, setRemarks] = useState('');
  // console.log(typeof perMonthPointsResult)

  const [insertPointsDialog, setInsertPointsDialog] = useState(false);

  // 點數紀錄table
  async function funFindPointsRecord(para) {
    const result = await residentPointsRecord.find({ query: para });
    // console.log(result);
    return result && result.data ? result.data : [];
  }

  async function funCreatePointsRecord(obj) {
    await residentPointsRecord.create(obj);
  }
  async function funUpdatePointsRecord(id, obj) {
    await residentPointsRecord.update(id, obj);
  }
  async function funRemovePointsRecord(id) {
    await residentPointsRecord.remove(id);
  }

  function ordersort(a, b) {
    return a.order < b.order ? 1 : -1;
  }

  function serverPointsRecordDataUpdate() {
    funFindPointsRecord({}).then((result) => {
      setResidentPointsRecordArr(result.sort(ordersort));
    });
  }
  useEffect(() => {
    serverPointsRecordDataUpdate();
  }, []);

  // find residentAccountNumbersAll data
  async function funFindResidentAll(para) {
    const result = await residentAccountNumbers.find({ query: para });
    return result && result.data ? result.data : [];
  }
  async function funCreateResidentAll(obj) {
    await residentAccountNumbers.create(obj);
  }
  async function funUpdateResidentAll(id, obj) {
    await residentAccountNumbers.update(id, obj);
  }
  async function funRemoveResidentAll(id) {
    await residentAccountNumbers.remove(id);
  }

  function householdNumberAllSort(a, b) {
    return a.building > b.building
      ? 1
      : -1 && a.floor > b.floor
      ? 1
      : -1 && a.floorChild > b.floorChild
      ? 1
      : -1;
  }

  function serverResidentAllDataUpdate() {
    funFindResidentAll({}).then((result) => {
      setResidentAccountNumbersAllArr(result.sort(householdNumberAllSort));
    });
  }
  useEffect(() => {
    serverResidentAllDataUpdate();
  }, []);

  // find residentAccountNumbers data
  async function funFindResident() {
    const result = await residentAccountNumbers.find({
      query: {
        householdNumber: dataSourceSelect,
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funCreateResident(obj) {
    await residentAccountNumbers.create(obj);
  }
  async function funUpdateResident(id, obj) {
    await residentAccountNumbers.update(id, obj);
  }
  async function funRemoveResident(id) {
    await residentAccountNumbers.remove(id);
  }

  function householdNumberSort(a, b) {
    return a.building > b.building
      ? 1
      : -1 && parseInt(a.floor) > parseInt(b.floor)
      ? 1
      : -1 && parseInt(a.floorChild) > parseInt(b.floorChild)
      ? 1
      : -1;
  }

  function serverResidentDataUpdate() {
    funFindResident().then((result) => {
      setResidentAccountNumbersArr(result.sort(householdNumberSort));
    });
  }
  useEffect(() => {
    serverResidentDataUpdate();
  }, [dataSourceSelect]);

  const dataSource = [];

  for (let i = 0; i < residentAccountNumbersAllArr.length; i++) {
    // 第一層
    const building = residentAccountNumbersAllArr[i].building;
    let objBuilding = dataSource.find((item) => item.label === building);
    if (!objBuilding) {
      objBuilding = {
        value: `${building}`,
        label: `${building}`,
        children: [],
      };
      dataSource.push(objBuilding);
    }
    // 第二層
    const floor = residentAccountNumbersAllArr[i].floor;
    let objFloor = objBuilding.children.find((item) => item.label === floor);
    if (!objFloor) {
      objFloor = {
        value: `${building}-${floor}`,
        label: `${floor}`,
        children: [],
      };
      objBuilding.children.push(objFloor);
    }

    // 第三層
    const floorChild = residentAccountNumbersAllArr[i].floorChild;
    let objFloorChild = dataSource.find((item) => item.label === floorChild);
    if (!objFloorChild) {
      objFloorChild = {
        value: `${building}-${floor}-${floorChild}`,
        label: `${floorChild}`,
      };
      objFloor.children.push(objFloorChild);
    }
    // console.log(`==${i}th dataSource:`,dataSource)
  }
  return (
    <>
      <Form {...formItemLayout}>
        <Form.Item
          label="戶號:"
          required
          requiredTrigger="onBlur"
          requiredMessage="必填"
        >
          <CascaderSelect
            name="accountNumbers"
            placeholder="請先選擇戶號"
            dataSource={dataSource}
            onChange={(value, data, extra) => {
              setDataSourceSelect(
                extra.selectedPath.map((item) => item.label).join('-')
              );
            }}
          />
        </Form.Item>
        <Form.Item
          label="點數:"
          // hasFeedback
          // required
          requiredTrigger="onBlur"
          format="number"
          // requiredMessage="必填"
          // formatMessage="只能填數字"
        >
          <Radio.Group
            name="checked"
            disabled={!dataSourceSelect}
            shape="button"
            size="large"
            onChange={(value) => {
              setPointsType(value);
            }}
          >
            <Radio
              disabled={!!perMonthPointsResult}
              id="addPoints"
              value="addPoints"
              name="addPoints"
            >
              新增點數
            </Radio>
            <Radio
              name="minusPoints"
              disabled={!!perMonthPointsResult}
              style={{ marginLeft: 10 }}
              id="minusPoints"
              value="minusPoints"
            >
              減少點數
            </Radio>
            {/* <Radio
              style={{ marginLeft: 10 }}
              id="perMonthPoints"
              value="perMonthPoints"
              onClick={() => {
                setInsertPointsDialog(true);
              }}
            >
              每月點數匯入
            </Radio> */}
          </Radio.Group>
          <Button
            disabled={!dataSourceSelect}
            onClick={() => {
              setInsertPointsDialog(true);
            }}
            style={{ marginLeft: 10 }}
          >
            每月點數匯入
          </Button>
          <Input
            disabled={!perMonthPointsResult}
            style={{ width: 150, marginLeft: 10 }}
            placeholder="每月點數"
            name="monthPoints"
            value={perMonthPointsResult}
          />
          <Dialog
            hasMask
            className={styles.dialog}
            visible={insertPointsDialog}
            footer={false}
            onClose={() => {
              setInsertPointsDialog(false);
            }}
          >
            <PerMonthPointsList
              residentAccountNumbersArr={residentAccountNumbersArr}
              setPerMonthPointsResult={setPerMonthPointsResult}
              perMonthPointsResult={perMonthPointsResult}
              insertPointsDialog={insertPointsDialog}
              setInsertPointsDialog={setInsertPointsDialog}
            />
          </Dialog>
          <br /> <br />
          <Input
            disabled={perMonthPointsResult ? true : !(false || pointsType)}
            placeholder="請輸入點數"
            name="changePoints"
            onChange={(value) => {
              setChangePoints(parseInt(value));
            }}
          />
        </Form.Item>
        <Form.Item label="備註">
          <Input
            name="remarks"
            placeholder="說明文字"
            onChange={(value) => {
              setRemarks(value);
            }}
          />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 6 }}>
          <Form.Submit
            validate
            type="primary"
            onClick={() => {
              try {
                const item = residentAccountNumbersArr[0];
                item.finalPoints = perMonthPointsResult
                  ? item.finalPoints + perMonthPointsResult
                  : '' || pointsType === 'addPoints'
                  ? item.finalPoints + changePoints
                  : item.finalPoints - changePoints;
                // console.log(typeof item.finalPoints)
                funUpdateResident(item._id, item).then(() => {
                  serverResidentDataUpdate();
                });
                funCreatePointsRecord({
                  order: residentPointsRecordArr.length,
                  createdTime: new Date().getTime(),
                  updatedTime: new Date().getTime(),
                  changePoints: perMonthPointsResult
                    ? +perMonthPointsResult
                    : '' || pointsType === 'addPoints'
                    ? +changePoints
                    : -changePoints,
                  finalPoints: item.finalPoints,
                  householdNumber: dataSourceSelect,
                  remarks,
                }).then(() => {
                  serverPointsRecordDataUpdate();
                });
              } catch (e) {
                // console.log(e);
              }
            }}
            style={{ marginRight: 10 }}
          >
            送出
          </Form.Submit>
          <Form.Reset
            onClick={() => {
              setPerMonthPointsResult('');
            }}
          >
            清除
          </Form.Reset>
        </Form.Item>
      </Form>
      <Table dataSource={residentPointsRecordArr}>
        <Table.Column title="編號" dataIndex="order" width={100} />
        <Table.Column
          title="建立時間"
          dataIndex="createdTime"
          width={100}
          cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
        />
        <Table.Column title="戶號" dataIndex="householdNumber" width={100} />
        <Table.Column title="變動點數" dataIndex="changePoints" width={100} />
        <Table.Column title="最後點數" dataIndex="finalPoints" width={100} />
        <Table.Column title="備註" dataIndex="remarks" width={100} />
        <Table.Column
          title="更新時間"
          dataIndex="updatedTime"
          width={100}
          cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
        />
      </Table>
    </>
  );
};

export default HouseholdPoints;
